import React, { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";

const AllotmentSuccessModal = ({ open }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [seconds, setSeconds] = useState(3); // countdown start value

  useEffect(() => {
    if (!open) return;

    setSeconds(3); // reset timer every time modal opens

    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [open]);

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 20000,
        pointerEvents: "auto",
        background: "rgba(255,255,255,0.7)",
        animation: "fadeIn 0.4s ease-in-out",
        transition: "opacity 0.4s ease-in-out",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: isMobile ? "1.5rem" : "2rem",
          textAlign: "center",
          width: isMobile ? "320px" : "450px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
          pointerEvents: "auto",
          animation: "scaleIn 0.4s ease-out",
        }}
      >
        {/* Success Tick */}
        <div
          style={{
            width: "5rem",
            height: "5rem",
            borderRadius: "50%",
            backgroundColor: "#e6fff1",
            border: "3.5px solid #00c853",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 auto 1.5rem",
          }}
        >
          <span style={{ fontSize: "2.5rem", color: "#00c853" }}>✓</span>
        </div>

        {/* Message */}
        <h2 style={{ fontWeight: 600,fontSize:isMobile?"2.5rem":"2rem", color: "#333", marginBottom: "0.75rem" }}>
          🎉 Congratulations!
        </h2>
        <p
          style={{
            color: "#555",
            fontSize: isMobile?"1.5rem":"1.2rem",
            lineHeight: "1.5",
            marginBottom: "1rem",
          }}
        >
          Your allotment is confirmed!
        </p>

        {/* Countdown */}
        <p style={{ fontSize: isMobile?"2rem":"1.8rem", color: "#777", marginTop: "1rem" }}>
          
          <b style={{ color: "#548aeeff" }}>{seconds}s</b> 
        </p>
      </div>

      {/* Animations */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes scaleIn {
            from { transform: scale(0.95); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default AllotmentSuccessModal;
